/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Вид для формы условия оплаты в форме организатора совместных покупок
   */
  app.JointPurchasePaymentFormView = app.FormView.extend({
    template: '#joint-purchase-payment-template',
    events: {
      'input .field.input_styled': 'validateLocal',
      'blur .field.input_styled': 'validateLocal',
      'blur .field': 'save',
      'click .js-remove-button': 'removeThisInterval'
    },
    run: function () {
      var json = app.helpers.TemplateHelper.getJson('#joint-purchase-payment-methods-json');
      this.methods = new app.Collection(json, {
        model: app.Model
      });
      this.template = app.helpers.TemplateHelper.getTemplate(this.template);
    },
    render: function () {
      this.setElement($(this.template({
        model: this.model,
        methods: this.methods.toJSON(),
        active: this.methods.get(this.model.get('jp_payment_method_id')),
        first: this.model.collection[0] == this,
        collectionLength: this.model.collection.length
      })));
      this.$fields = this.$(this.formElement);
      
      this.childViews.selectView = new app.SelectView({
        el: this.$('.select-with-input'),
        model: this.model,
        activeValueSelector: '.select_active',
        field: 'jp_payment_method_id',
        inputSelector: 'input',
        optionsSelector: '.js-options'
      });
      
      return this.el;
    },
    save: function () {
      this.model.set(this.getData());
    },
    removeThisInterval: function () {
      var collection = this.model.collection,
        options = {
          dont_save: true
        };
      if (collection) {
        collection.remove(this.model, options);
        if (collection.length > 0) {
          collection.last().set({sum_to: null}, options);
        }
        collection.trigger('update', this.model, collection);
      }
    },
    validateLocal: function (e) {
      var $target = $(e.target),
        newValue = $target.val();
      
      //убираем не цифры
      newValue = newValue.replace(/[^0-9-]/g, '');
      //убираем нули в начале
      newValue = newValue.replace(/\b0+/g, '');
      //Подставляем 0 в пустую строку, но не у sum_to
      if (newValue === '' && $target.attr('placeholder') !== '∞') {
        newValue = 0;
      }
      $target.val(newValue);
    },
    /**
     * Переопределяем, чтобы все значения типа string переводились в int, если это возможно,
     * чтобы при сохранениие в модели "123" вместо 123 не вызывалось событие "update"
     * @returns {*}
     */
    getData: function () {
      var data = app.FormView.prototype.getData.call(this),
        parseIntResult;
      
      _.each(data, function (value, name) {
        parseIntResult = parseInt(data[name], 10);
        if (parseIntResult.toString() === data[name]) {
          data[name] = parseIntResult;
        }
      });
      
      return data;
    }
  });
})(jQuery);

}.call(window));